import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import {
  mobile,
  TextLink,
  FilterTags as BaseFilterTags,
  ProductBrowserCustomFilters as BaseProductBrowser,
} from '@techstyle/react-components';

import { usePageNum } from '../GridPageNumProvider/GridPageNumProvider';

const headerStyle = css`
  font-size: 12px;
  letter-spacing: ${1.75 / 12}em;
  color: ${props => props.theme.colors.subdued};
  text-transform: uppercase;
  line-height: 1.2;
  margin-bottom: 8px;
`;

const tagStyle = css`
  &&& {
    background-color: ${({ theme }) => theme.colors.marble};
    border-radius: 34px;
    letter-spacing: ${0.3 / 12}em;
    margin: 10px 10px 0 0;
    padding: 0 4px 0 12px;
    color: ${({ theme }) => theme.colors.black};
    button {
      height: 26px;
      width: 26px;
    }
    ${({ theme }) => theme.subHeader.variants.subHeading4.textStyles}
  }
`;

const ClearAllButton = styled(TextLink).attrs(props => ({
  tagName: 'button',
}))`
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 1.75px;
  text-transform: uppercase;
  cursor: pointer;
  margin-bottom: ${props => props.theme.spacing.tiny}px;
  line-height: 1.2;

  ${mobile`
    margin-bottom: ${props => props.theme.spacing.small}px;
  `}

  color: ${props => props.theme.colors.gunmetal};
  border-bottom: 1px solid ${props => props.theme.colors.gunmetal};
`;

const deselectButtonStyle = css`
  &&& {
    font-size: 12px;
    height: auto;
    border-radius: 50%;
    padding: 3px 6px;
    padding-bottom: 4px;
    margin: 4px;
    margin-left: 6px;
    background-color: ${props => props.theme.colors.white};
  }

  & svg {
    color: ${props => props.theme.colors.default};
  }
`;

const FilterTags = React.forwardRef(
  ({ as: ElementType = BaseFilterTags, onClick = () => {}, ...rest }, ref) => {
    const { setPageNum } = usePageNum();

    const handleOnClick = useCallback(() => {
      onClick();

      setPageNum(1);
    }, [onClick, setPageNum]);

    return (
      <ElementType
        clearAllButtonComponent={ClearAllButton}
        deselectButtonStyle={deselectButtonStyle}
        headerStyle={headerStyle}
        tagStyle={tagStyle}
        ref={ref}
        as={BaseProductBrowser.FilterTags}
        onClick={handleOnClick}
        {...rest}
      />
    );
  }
);

FilterTags.displayName = 'FilterTags';
FilterTags.propTypes = { as: PropTypes.elementType };
export default FilterTags;
